export type HttpResponseType<T> = {
  success: boolean;
  status: number;
  response?: T;
  error?: any;
};

type HttpOptions = {
  host: string;
  method: "GET" | "PUT" | "POST" | "DELETE";
  pathname?: string;
  queryParams?: string;
  headers?: object;
  payload?: any;
  expectedResponse?: {
    json?: boolean;
  };
};

export async function http<T>({
  host,
  method,
  pathname,
  queryParams,
  headers,
  payload,
  expectedResponse,
}: HttpOptions): Promise<HttpResponseType<T>> {
  const url = `${host}${pathname ? `/${pathname}` : ""}${queryParams ? `?${queryParams}` : ""}`;

  const returnResponse = (toResolve: HttpResponseType<T>, resolve: (value: HttpResponseType<T> | PromiseLike<HttpResponseType<T>>) => void) => {
    resolve(toResolve);
  };

  return await new Promise(async (resolve) => {
    fetch(url, {
      method,
      headers: {
        ...headers,
      },
      body: payload,
    })
      .then((response) => {
        const { status } = response;
        switch (status) {
          case 200:
          case 201:
          case 202:
          case 203:
          case 204:
            if (expectedResponse?.json) {
              response.json().then((response) => {
                returnResponse({ success: true, status, response }, resolve);
                return;
              });
            } else {
              returnResponse({ success: true, status }, resolve);
            }
            return;
          default:
            response.text().then((response) => {
              returnResponse({ success: false, status, error: response }, resolve);
            });
            return;
        }
      })
      .catch((error) => {
        returnResponse({ success: false, status: 500, error: error.toString() }, resolve);
      });
  });
}

export default {
  http,
};
